import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * One toaster for the whole app, mounted in App. Positioned top-centre: on a
 * phone the bottom of the screen is where the action bar and the thumb are.
 */
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="top-center"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'rounded-xl! shadow-lg! font-sans!',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
